module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/zoom-minus-68dcbdc7eda962874c0ffc76ae7dbd3f.svg";